import axios from "axios";

let debug = window.location.host.indexOf("localhost") !== -1;
const ENDPOINT = debug ? "http://localhost:5029" : "https://signme.io";
let token = null;

function url(uri) {
    return ENDPOINT + "/api/v1/" + uri;
}

function configure(config) {
    if (!config) config = {headers: {}};
    if (!config.headers) {
        config.headers = {};
    }
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}


async function apiPost(uri, data, config) {
    config = configure(config);
    return await axios.post(url(uri), data, config);
}

async function apiPut(uri, data, config) {
    config = configure(config);
    return await axios.put(url(uri), data, config);
}

async function apiGet(uri, config) {
    config = configure(config);
    return await axios.get(url(uri), config);
}

async function apiDelete(uri, config) {
    config = configure(config);
    return await axios.delete(url(uri), config);
}

function apiSetAccessToken(newTok) {
    token = newTok;
}

let apiURL = url;

export {apiPost, apiDelete, apiPut, apiURL, apiGet, url, configure, apiSetAccessToken};